
  import { EventBus } from '@/ui/EventBus';
  import { Events } from '@/ui/events';
  import { defineComponent, onBeforeUnmount, ref } from 'vue';

  interface FormAction {
    uuid: string;
    visible_for_conductor: boolean;
  }

  interface InvalidAction {
    uuid: string;
  }

  interface FormActionProps {
    item: FormAction;
  }

  interface showErrorProps {
    invalidAction: InvalidAction;
  }

  export default defineComponent<FormActionProps>({
    props: {
      item: {
        type: Object,
        required: true,
        default: () => ({}),
      },
      errors: {
        type: Object,
        required: true,
      },
      showErrors: {
        type: Boolean,
        required: true,
      },
      responseSets: {
        type: Array,
        required: true,
      },
    },
    setup(props: FormActionProps) {
      const isShowingErrors = ref(false);
      const onShowErrors = (error: showErrorProps) => {
        if (error.invalidAction.uuid && error.invalidAction.uuid === props.item.uuid) {
          isShowingErrors.value = true;
        }
      };

      const onInspectionSubmit = () => {
        isShowingErrors.value = false;
      };

      EventBus.$on(Events.showErrorsInvalidActions, onShowErrors);
      EventBus.$on(Events.preSubmitInspection, onInspectionSubmit);

      onBeforeUnmount(() => {
        EventBus.$off(Events.showErrorsInvalidActions, onShowErrors);
        EventBus.$off(Events.preSubmitInspection, onInspectionSubmit);
      });

      return {
        isShowingErrors
      };
    }
  });
